import { PLATFORM_STATS } from '../constants/platformStats.js';

var getTransporterFigureTypes;
(function (getTransporterFigureTypes) {
    getTransporterFigureTypes[getTransporterFigureTypes["NUMERIC"] = 0] = "NUMERIC";
    getTransporterFigureTypes[getTransporterFigureTypes["THOUSANDS"] = 1] = "THOUSANDS";
    getTransporterFigureTypes[getTransporterFigureTypes["MILLIONS"] = 2] = "MILLIONS";
    getTransporterFigureTypes[getTransporterFigureTypes["LAKHS"] = 3] = "LAKHS";
    getTransporterFigureTypes[getTransporterFigureTypes["LAKH_NUMBER"] = 4] = "LAKH_NUMBER";
})(getTransporterFigureTypes || (getTransporterFigureTypes = {}));
const getTransporterFigure = (type = getTransporterFigureTypes.LAKHS) => {
    switch (type) {
        case getTransporterFigureTypes.THOUSANDS:
            return "1000 Thousand+";
        case getTransporterFigureTypes.MILLIONS:
            return "1 Million+";
        case getTransporterFigureTypes.NUMERIC:
            return PLATFORM_STATS.transporters.numeric;
        case getTransporterFigureTypes.LAKH_NUMBER:
            return `${PLATFORM_STATS.transporters.lakhNumber}`;
        default:
            return PLATFORM_STATS.transporters.lakhsLong;
    }
};

export { getTransporterFigure, getTransporterFigureTypes };
//# sourceMappingURL=getTransporterFigure.js.map
